import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';

export const ProductListingPageContext = React.createContext({});

const ProductListingPageProvider = ({ children, ...rest }) => {
  const isMobile = useMedia('(max-width: 767px)');
  const isSmall = useMedia('(max-width: 359px)');
  const defaultColumns = useMemo(() => {
    if (isMobile || isSmall) {
      return 2;
    }
    return 3;
  }, [isMobile, isSmall]);
  const [columns, setColumns] = useState(defaultColumns);

  useEffect(() => {
    setColumns(defaultColumns);
  }, [defaultColumns]);

  return (
    <ProductListingPageContext.Provider value={{
      isMobile,
      columns,
      setColumns,
      bundleImage: window.Shopify.bundleImage,
      lookImage: window.Shopify.lookImage,
      ...rest,
    }}
    >
      {children}
    </ProductListingPageContext.Provider>
  );
};

ProductListingPageProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { ProductListingPageProvider };
